import React, { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useProductSkuConfig } from '../../context';
import { createModalFooterMessage } from '../../methods';
import { PRODUCT_SKU_CONFIG_KEYS as DATA_KEYS } from '../../../../../../stubs';
import ProductsSearchTable from '../ProductsSearchTable';

export default function ProductsModal({ isOpen = false, onClose = () => {} }) {
  const { id: exceptionId } = useParams();

  const { formData, onFormDataChange } = useProductSkuConfig();

  const [newProducts, setNewProducts] = useState([]);

  const products = useMemo(() => _get(formData, DATA_KEYS.PRODUCTS, []), [
    formData
  ]);

  const onChange = useCallback(products => setNewProducts(products), []);

  const onConfirm = useCallback(() => {
    onFormDataChange(DATA_KEYS.PRODUCTS, newProducts);
    onClose();
  }, [onClose, onFormDataChange, newProducts]);

  const footerMessage = useMemo(() => {
    return createModalFooterMessage(newProducts);
  }, [newProducts]);

  return (
    <UiKit.SideSheet
      size="lg"
      hideCancelButton
      backdrop="static"
      isOpen={isOpen}
      title="Select SKUs"
      onConfirm={onConfirm}
      onClose={onClose}
      bodyClassName={styles.content}
      footerInfo={footerMessage}
      confirmBtnVariant="primary"
      confirmBtnText="Confirm SKUs"
    >
      <ProductsSearchTable
        windowId={exceptionId}
        data={products}
        onDataChange={onChange}
      />
    </UiKit.SideSheet>
  );
}
